import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClimateCareEnergyComponent } from './energy.component';
import {OffsetInputModule} from '../../../shared/components/offset-input/offset-input.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PurchaseEmissionsModule} from '../purchase-emissions/purchase-emissions.module';
import {GenericTypeaheadModule} from '../../../shared/components/generic-typeahead/generic-typeahead.module';

@NgModule({
  declarations: [
    ClimateCareEnergyComponent
  ],
  imports: [
    CommonModule,
    OffsetInputModule,
    FormsModule,
    ReactiveFormsModule,
    PurchaseEmissionsModule,
    GenericTypeaheadModule
  ],
  exports: [
    ClimateCareEnergyComponent
  ],
})
export class ClimateCareEnergyModule { }
